import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'monitoringTypeChooser',
    path: '/monitoring',
    component: () => import('../pages/MonitoringTypeChooserPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'monitoringSimple',
    path: '/monitoring/simple',
    component: () => import('../pages/MonitoringPage.vue'),
    props: { isAdvanced: false },
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'monitoringAdvanced',
    path: '/monitoring/advanced',
    component: () => import('../pages/MonitoringPage.vue'),
    props: { isAdvanced: true },
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'monitoringTables',
    path: '/monitoring/tables',
    component: () => import('../pages/MonitoringParcelsPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
